import React, {Component} from 'react';

import '../css/components/Objectifs.css';
import BlocCta from './BlocCta';

export default class Objectifs extends Component {
    constructor(props) {
        super(props)
        this.extraClassName = props.extraClassName;
    }

    render() {
        const {src, objectives} = this.props;

        if (!Array.isArray(objectives)) return null

        return (
            <BlocCta extraClassName={"shrink gradient-orange-bleu " + (this.extraClassName ? this.extraClassName : '')}
                     image={{src: src, alt: "objectifs"}}
                     title="Les objectifs">
                <div className={"custom-ol"}>
                    <ul>
                        {
                            objectives.map((o, index) => (
                                <li key={index}>
                                    <span></span>
                                    <div dangerouslySetInnerHTML={{__html: o}}></div>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </BlocCta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Objectifs.js